// Thin wrapper around localStorage with JSON handling and namespace prefix.
const PREFIX = "paysafi.";

export function readKey(key, fallback) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeKey(key, value) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // ignore quota errors in demo
  }
}

export function removeKey(key) {
  localStorage.removeItem(PREFIX + key);
}

export function genId(prefix = "id") {
  return `${prefix}_${Date.now().toString(36)}${Math.random()
    .toString(36)
    .slice(2, 6)}`;
}
